import { useTrack } from '@hotjar/tracking';
import { useStoreState } from '@hotjar/recordings/src/store/player/context';
import type { Site } from '@hotjar/site';
import type { Suggestion } from '@hotjar/webapp/features/Activation/SpaceOverview/components/SuggestionsBox/useSuggestions';
import { useErrorReportingSuggestion } from './hook/useErrorReportingSuggestion';
import { TileContainer, StyledTile } from './styles';

export const ErrorReportingTile = ({ site }: { site: Site }): JSX.Element | null => {
  const { suggestion, dismiss } = useErrorReportingSuggestion(site);
  const { toggleConsole } = useStoreState();

  const { click, viewElement } = useTrack();
  const trackClick = (element: string) => click(element, 'Suggestion Tile - Player', {});
  const onTileClick = (
    tile: Suggestion,
    e: React.MouseEvent<HTMLAnchorElement>,
    silent = false,
  ) => {
    e.preventDefault();
    toggleConsole();
    trackClick(tile.id);
    dismiss(silent);
  };
  const onTileDismiss = (tile: string) => {
    trackClick(`${tile} Dismiss - Player`);
    dismiss();
  };
  const handleElementViewed = (element: string) => {
    viewElement(element, 'Suggestion Tile - Player', {});
  };

  return (
    suggestion && (
      <TileContainer>
        <StyledTile
          id={suggestion.id}
          title={suggestion.title}
          description={suggestion.description}
          href={suggestion.href}
          image={suggestion.image}
          isExternalLink={suggestion.isExternalLink}
          onClick={(e) => onTileClick(suggestion, e, true)}
          onDismiss={() => onTileDismiss(suggestion.id)}
          onView={handleElementViewed}
        />
      </TileContainer>
    )
  );
};
